import { z } from 'zod';
import { HexColorSchema, ThemeColorSchema } from '../util/color.js';
export const OwnerEmailThemeSchema = z.object({
    /** Background of the header and footer sections, e.g. #2A2163 */
    headerFooterColor: HexColorSchema,
    /** Text and links on the header and footer; contrasts with `headerFooterColor` when unset */
    headerFooterTextColor: HexColorSchema.optional(),
    /** Background of call-to-action buttons, e.g. #2daf99 */
    buttonColor: HexColorSchema,
    /** Button text; contrasts with `buttonColor` when unset */
    buttonTextColor: HexColorSchema.optional(),
    /** Not used by any email template yet */
    accentColor: HexColorSchema,
    accentForegroundColor: HexColorSchema.optional(),
    /** Emphasized inline text, e.g. "Portal Tour" in the welcome email #25af98 */
    highlightTextColor: HexColorSchema,
    /** Font family for the owner - future use */
    headingFontFamily: z.string(),
    bodyFontFamily: z.string(),
});
export const OwnerUiThemeSchema = z.object({
    primaryColor: ThemeColorSchema,
    primaryForegroundColor: ThemeColorSchema.optional(),
    secondaryColor: ThemeColorSchema,
    secondaryForegroundColor: ThemeColorSchema.optional(),
    accentColor: ThemeColorSchema,
    accentForegroundColor: ThemeColorSchema.optional(),
    mutedColor: ThemeColorSchema,
    mutedForegroundColor: ThemeColorSchema.optional(),
    borderColor: ThemeColorSchema.optional(),
    inputColor: ThemeColorSchema.optional(),
    ringColor: ThemeColorSchema.optional(),
    sidebarColor: ThemeColorSchema,
    sidebarForegroundColor: ThemeColorSchema.optional(),
    sidebarPrimaryColor: ThemeColorSchema,
    sidebarPrimaryForegroundColor: ThemeColorSchema.optional(),
    sidebarAccentColor: ThemeColorSchema,
    sidebarAccentForegroundColor: ThemeColorSchema.optional(),
    sidebarBorderColor: ThemeColorSchema.optional(),
    sidebarRingColor: ThemeColorSchema.optional(),
    /** Font family for the owner - future use */
    headingFontFamily: z.string(),
    bodyFontFamily: z.string(),
});
/** Split by surface: the two are themed independently. */
export const OwnerThemeSchema = z.object({
    email: OwnerEmailThemeSchema,
    ui: OwnerUiThemeSchema,
});
